import { GithubContext } from '@mode/github/contract';
import { AppState } from '@mode/legacy/types-app-state';

const selectedDefinition = (state: AppState) => state.client.selectedDefinition;

export const selectedDefinitionQuery = (state: AppState) => selectedDefinition(state)?.query;
export const selectedDefinitionQueryResource = (state: AppState) => selectedDefinitionQuery(state)?.resource;

const selectedDefinitionState = (state: AppState) => selectedDefinition(state)?.definition;
const selectedDefinitionToken = (state: AppState) => selectedDefinitionState(state)?.token;
const selectedDefinitionName = (state: AppState) => selectedDefinitionState(state)?.name;
const selectedDefinitionUpdatedAt = (state: AppState) => selectedDefinitionState(state)?.updated_at;
const selectedDefinitionLastSuccessfulSync = (state: AppState) => selectedDefinitionState(state)?.lastSyncedAt;

const selectedDefinitionResource = (state: AppState) => selectedDefinitionState(state)?.resource;
const selectedDefinitionGithubForm = (state: AppState) => selectedDefinitionResource(state)?.forms('sync_to_github');
const selectedDefinitionGithubLink = (state: AppState) => selectedDefinitionResource(state)?.github_link;

export const selectedDefinitionGithubState = (state: AppState): GithubContext => ({
  syncToGithubForm: selectedDefinitionGithubForm(state),
  githubLink: selectedDefinitionGithubLink(state),
  lastRunAt: selectedDefinitionUpdatedAt(state),
  lastSavedAt: selectedDefinitionUpdatedAt(state), // Run and Save are the same for definitions
  lastSuccessfulSyncAt: selectedDefinitionLastSuccessfulSync(state)?.toString(),
  syncTargetToken: selectedDefinitionToken(state),
  syncTargetName: selectedDefinitionName(state),
  workspace: undefined, // We don't have the workspace name in this part of the store. Something upstream will have to fill it in
});
